import type { CatalogueEntry } from "../types";
import imageLight from "../images/national-buildings.light.webp";
import imageDark from "../images/national-buildings.dark.webp";

export const entry: CatalogueEntry = {
  slug: "national-buildings",
  displayName: `National Buildings`,
  datasetProductCode: `GEOSCAPE BUILDINGS`,
  subtitle: `Spatial Representation of Australian Building Features`,
  shortDescription: `Buildings is a national digital dataset representing buildings for each State and Territory in Australia. The purpose of Buildings is to spatially represent building related features for use by industry and government in geographic information systems, visualisations, engineering modelling, and for the derivation of analytics.
The Buildings product is comprised of four layers; buildings, building_cad, building_property and building_address. The buildings layer provides a spatial representation of the roof outline of a building as well as associated attribution including building height values, roof material and colour, and building area and volume. The aspatial building_cad, building_property and building_address tables provide additional information related to a building.`,
  metadata: {
    dateAdded: 1482105600000,
    dataType: ["Polygons"],
    theme: `Built Environment`,
    totalFeatureCount: 19137497,
    updateFrequency: `Quarterly`,
    license: `Commercial`,
    metadataXml: `[EXAMPLE](https://geoscape.com.au/)`,
    metadataJson: `[EXAMPLE](https://geoscape.com.au/)`,
  },
  latestReleaseReportLink: `https://docs.geoscape.com.au/en/stable/buildings.html`,
  productDescriptionLink: `https://docs.geoscape.com.au/en/stable/buildings.html`,
  imageLight,
  imageDark,
  searchTags: `National Buildings 5g 5g Modelling Architecture Asset Management Buildings Heights Bushfire risk Construction Construction Details Development Flood Risk Net 0 Net-zero Risk Geoscape Buildings Modelling Safety Sound Modelling Urban Planning`,
  detail: () => import("../details/national-buildings").then((m) => m.detail),
};

export default entry;
